import RequestRoutes from '@/router/RequestsRoutes';
import CarnetRoutes from '@/router/CarnetRoutes';
import AppointmentsRoutes from '@/router/AppointmentsRoutes';

const SidebarRoutes = [
  {
    path: '',
    component: () => import('@/layouts/SidebarLayout.vue'),
    children: [
      ...RequestRoutes,
      ...CarnetRoutes,
      ...AppointmentsRoutes,
    ],
  },
];

export default SidebarRoutes;
